import React, { useContext, useEffect, useMemo, useState } from "react";
import { languages, navigateWithLang } from "../../utils/lang";
import { useLocation } from "@gatsbyjs/reach-router";
import { PhosphorIcon } from "../PhosphorIcon/PhosphorIcon";
import { Icons } from "../PhosphorIcon/types";
import { LangContext } from "../../context/lang/LangContext";
import toTitle from "../../utils/toTitle";
import { Link } from "gatsby";

export const LangSelect = () => {
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  const { messages } = useContext(LangContext);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const currentLang = useMemo(() => {
    return (
      languages.find((lang) => lang.shortName === messages.currentLanguage) ||
      languages[0]
    );
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node))
        setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div ref={ref} className="LangSelect__container">
        <span
          className="LangSelect__Select"
          onClick={handleOpen}
          data-testid="open-button"
        >
          <span>{toTitle(currentLang.shortName)}</span>
          <PhosphorIcon icon={Icons.CaretDown} size={16} />
        </span>
        {isOpen && (
          <div className="LangSelect__options">
            {languages.map((lang, index) => (
              <Link
                key={index}
                to={navigateWithLang(lang.code, location)}
                className="LangSelect__option"
              >
                {lang.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
